import {NgModule}                   from "@angular/core";
import {RouterModule, Routes}       from "@angular/router";
import {LoginScreenComponent}       from "./core/login-screen/login-screen.component";
import {NotFoundScreenComponent}    from "./core/not-found-screen/not-found-screen.component";
import {HomeComponent}              from "./core/home/home.component";
import {AuthGuard}                  from "./services/auth/auth.guard";
import {LegacyContainerComponent}   from "./legacy/container/legacy-container.component";

const routes: Routes = [
    {
        path:      "login",
        component: LoginScreenComponent
    },
    {
        path:        "",
        component:   HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: "legacy/:page",
        component: LegacyContainerComponent,
        canActivate: [AuthGuard]
    },
    {
        path: "modulo-geral",
        loadChildren: () => import("./modulo-geral/modulo-geral.module").then(m => m.ModuloGeral)
    },
    {
        path: "modulo-programacao",
        loadChildren: () => import("./modulo-programacao/modulo-programacao.module").then(m => m.ModuloProgramacao)
    },
    {
        path: "modulo-financeiro",
        loadChildren: () => import("./modulo-financeiro/modulo-financeiro.module").then(m => m.ModuloFinanceiro)
    },
    {
        path: "modulo-cortesia",
        loadChildren: () => import("./modulo-cortesia/modulo-cortesia.module").then(m => m.ModuloCortesia)
    },
    {
        path: "modulo-cashback",
        loadChildren: () => import("./modulo-cashback/modulo-cashback.module").then(m => m.ModuloCashback)
    },
    {
        path: "modulo-billy",
        loadChildren: () => import("./modulo-billy/modulo-billy.module").then(m => m.ModuloBilly)
    },
    {
        path: "modulo-estoque",
        loadChildren: () => import("./modulo-estoque/modulo-estoque.module").then(m => m.ModuloEstoque)
    },
    {
        path: "modulo-fiscal",
        loadChildren: () => import("./modulo-fiscal/modulo-fiscal.module").then(m => m.ModuloFiscal)
    },
    {
        path: "modulo-efd-fiscal",
        loadChildren: () => import("./modulo-efd-fiscal/modulo-efd-fiscal.module").then(m => m.ModuloEfdFiscal)
    },
    {
        path: "modulo-gerencial",
        loadChildren: () => import("./modulo-gerencial/modulo-gerencial.module").then(m => m.ModuloGerencial)
    },
    {
        path: "modulo-contabil",
        loadChildren: () => import("./modulo-contabil/modulo-contabil.module").then(m => m.ModuloContabil)
    },
    {
        path: "modulo-ancine",
        loadChildren: () => import("./modulo-ancine/modulo-ancine.module").then(m => m.ModuloAncine)
    },
    {
        path: "modulo-controle-cortesia",
        loadChildren: () => import("./modulo-controle-cortesia/modulo-controle-cortesia.module").then(m => m.ModuloControleCortesia)
    },
    {
        path: "modulo-cartvip",
        loadChildren: () => import("./modulo-cartvip/modulo-cartvip.module").then(m => m.ModuloCartvipModule)
    },
    {
        path:      "**",
        component: NotFoundScreenComponent
    }
];


@NgModule({
    imports:   [RouterModule.forRoot(routes)],
    exports:   [RouterModule],
    providers: [AuthGuard]
})


export class AppRoutingModule {
}
